"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentHelpers = void 0;
class CommentHelpers {
    static pickTodoChangeComment(itemName, done, lastIndex, keys) {
        let index;
        do {
            index = Math.floor(Math.random() * keys.length);
        } while (keys.length > 1 && index === lastIndex);
        const name = itemName.replace(/[&<>"']/g, (char) => `&#${char.charCodeAt(0)};`);
        const status = (done ? 'tutorial.todos.statusDone' : 'tutorial.todos.statusUndone').t();
        const comment = keys[index].t({ name, status });
        return { comment, newLastIndex: index };
    }
}
exports.CommentHelpers = CommentHelpers;
